import { render } from "./FundRecord.vue?vue&type=template&id=273fa155&scoped=true"
import script from "./FundRecord.vue?vue&type=script&lang=js"
export * from "./FundRecord.vue?vue&type=script&lang=js"

import "./FundRecord.vue?vue&type=style&index=0&id=273fa155&lang=less&scoped=true"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273fa155"]])

export default __exports__